import { lazy } from "react";
import { Link, Navigate, createBrowserRouter } from "react-router-dom";
import PolicyCheck from '../components/policies/PolicyCheck';
import ViewQuoteBootstrap from "../views/ViewQuoteBootstrap";

/****Layouts*****/
const FullLayout = lazy(() => import("../layouts/FullLayout.js"));
const Home = lazy(() => import("../views/Home.js"));

const Admin = lazy(() => import("../views/Admin.js"));
const ItemsTable = lazy(() => import("../features/items/components/ItemsTable.js"));
const ItemTypeCustomAttributesTable = lazy(() => import("../features/items/components/ItemTypeCustomAttributesTable.js"));
const AdminUsers = lazy(() => import("../features/users/components/AdminUsers.js"));
const AdminModules = lazy(() => import("../features/modules/components/AdminModules.js"));
const AdminTags = lazy(() => import("../features/tags/components/AdminTags.js"));
const AdminSuppliers = lazy(() => import("../features/suppliers/components/AdminSuppliers.js"));
const AdminSalesforce = lazy(() => import("../features/salesforceCodes/components/AdminSalesforce.js"));
const AdminAudit = lazy(() => import("../features/audit/components/AdminAudit.js"));
const AdminLog = lazy(() => import("../features/log/components/AdminLog.js"));
const AdminImportTemplates = lazy(() => import("../features/importTemplate/components/AdminImportTemplates.js"));
const AdminQuoteTemplates = lazy(() => import("../features/exportTemplates/quote/components/AdminQuoteTemplates.js"));
const AdminExportTemplates = lazy(() => import("../features/exportTemplates/sheet/components/AdminExportTemplates.js"));
const AdminExports = lazy(() => import("../features/adminExports/components/AdminExportTemplates.js"));

const Opportunities = lazy(() => import("../views/Opportunities.js"));
const ViewOpportunity = lazy(() => import("../views/ViewOpportunity.js"));

const Quotes = lazy(() => import("../views/Quotes.js"));
const About = lazy(() => import("../views/About.js"));

/*****Routes******/
///https://blog.logrocket.com/complete-guide-authentication-with-react-router-v6/#creating-protected-routes TIM TODO

const router = () => {
  const adminChildren = [
    { path: "items", title: "Catalogue", element: <ItemsTable allowShowingInactiveItems /> },
    { path: "itemattributes", title: "Item Types", element: <ItemTypeCustomAttributesTable /> },
    { path: "modules", title: "Module Management", element: <AdminModules /> },
    { path: "tags", title: "Tag Manager", element: <AdminTags /> },
    { path: "suppliers", title: "Supplier Management", element: <AdminSuppliers /> },
    { path: "salesforce-codes", title: "Salesforce Code Management", element: <AdminSalesforce /> },
    { path: "import-templates", title: "Import Template Management", element: <AdminImportTemplates /> },
    { path: "export-templates", title: "Export Template Management", element: <AdminExportTemplates /> },
    { path: "exports", title: "Exports", element: <AdminExports /> },
    { path: "quote-templates", title: "Quote Template Management", element: <AdminQuoteTemplates /> },
    { path: "users", title: "User Management", element: <AdminUsers /> },
    { path: "audit", title: "Audit", element: <AdminAudit /> }
  ];

  if (process.env.REACT_APP_SHOW_LOGS === "true") {
    adminChildren.push({ path: "log", title: "Log", element: <AdminLog /> });
  }

  return createBrowserRouter([
    {
      path: "/",
      element: <FullLayout />,
      children: [
        { path: "/", title: "Dashboard", exact: true, element: <Navigate to="/dashboard" replace /> },
        { path: "/dashboard", title: "Dashboard", exact: true, element: <Home /> },

        { path: "/admin", title: "Admin", element: <Navigate to="/admin/items" replace /> },
        {
          path: "/admin/*",
          title: "Admin",
          element:
            <PolicyCheck reqPolicies={["adminAccess"]} disabled>
              <Admin />
            </PolicyCheck>, 
          children: adminChildren
        },

        { path: "/opportunities", title: "Opportunities", exact: true, element: <Opportunities /> },
        { path: "/opportunities/:id", title: "Opportunity", exact: true, element: <ViewOpportunity /> },
        { path: "/opportunities/:id/:quoteId", title: "Opportunity", exact: true, element: <ViewQuoteBootstrap /> },
        { path: "/opportunities/:id/:quoteId/:quoteRevisionId", title: "Opportunity", exact: true, element: <ViewQuoteBootstrap /> },

        { path: "/quotes", title: "Quotes", exact: true, element: <Quotes /> },
        // { path: "quotes/:quoteId", title: "Quote", exact: true, element: <ViewQuote /> },
        // { path: "quotes/:quoteId/:quoteRevisionId", title: "Quote", exact: true, element: <ViewQuote /> },

        { path: "/about", title: "About", exact: true, element: <About /> },
      ]
    },
    { path: "*", element: <NoMatch /> }
  ]);
};

function NoMatch() {
  return (
    <div>
      <h2>Nothing to see here!</h2>
      <p>
        <Link to="/">Go to the home page</Link>
      </p>
    </div>
  );
}

export default router;
